
import { configureStore } from "@reduxjs/toolkit";
import gameReducer from "../reducers/gameReducer";
import { apiSlice } from "../reducers/apiSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import uiReducer from "../reducers/uiReducer";
import loginReducer from "../reducers/loginReducer";

export const store = configureStore({
    reducer: {
        game: gameReducer,
        ui: uiReducer,
        login: loginReducer,
        [apiSlice.reducerPath]: apiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(apiSlice.middleware), 
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
